import AddressHash from '@/components/AddressHash'
import styles from './index.module.less'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useTranslation } from 'react-i18next'
const GovListCard = ({
  address,
  index,
  page,
}: {
  address: string
  index: number
  page: number
}) => {
  const navigate = useMeNavigate()
  const { t } = useTranslation()
  return (
    <div className={styles.cardWrap}>
      <div className={styles.cardNum}>#{(page - 1) * 10 + index + 1}</div>
      <div className={styles.cardContent}>
        <div className={styles.cardTitle}>{t('explorer_114')}</div>
        <div className={styles.cardAddress}>
          <AddressHash
            data={address}
            copyIcon={'gray'}
            handleJump={() => {
              navigate(`/moduleAccount/${address}`)
            }}
          ></AddressHash>
        </div>
      </div>
    </div>
  )
}

export default GovListCard
